// src/.../components/home/FeaturedCategories.tsx
import React from "react";
import { useNavigate } from "react-router-dom";

import body from "../../../../../../assets/image/category/Body.webp";
import bracks1 from "../../../../../../assets/image/category/bracks1.webp";
import engine from "../../../../../../assets/image/category/engine.png";
import filters from "../../../../../../assets/image/category/Filters.webp";
import fluid from "../../../../../../assets/image/category/fluid.webp";
import radiators from "../../../../../../assets/image/category/radiators.webp";
import ignition from "../../../../../../assets/image/category/ignition.webp";
import belt from "../../../../../../assets/image/category/belt.webp";
import oxyzensensor from "../../../../../../assets/image/category/oxyzensensor.webp";
import sensorExhaust from "../../../../../../assets/image/category/sensorExhaust.webp";
import breakpad from "../../../../../../assets/image/category/break-pad.png";

const CATEGORIES = [
  {
    name: "BODY-REAR",
    img: body,
    id: "4893",
    make: "0005",
    model: "0108",
    year: "2019",
  },
  {
    name: "BRAKE PADS AND SHOES",
    img: breakpad,
    id: "0003",
    make: "0005",
    model: "0108",
    year: "2019",
  },
  {
    name: "FILTERS",
    img: filters,
    id: "0002",
    make: "0005",
    model: "0108",
    year: "2019",
  },
  {
    name: "FUNCTIONAL FLUID, LUBRICANT & GREASE",
    img: fluid,
    id: "2088",
    make: "0005",
    model: "0108",
    year: "2019",
  },
  {
    name: "BELTS, HOSES, TENSIONERS",
    img: belt,
    id: "0008",
    make: "0005",
    model: "24825",
    year: "2019",
  },
  {
    name: "ENGINE COMPONENTS",
    img: engine,
    id: "0020",
    make: "0005",
    model: "24825",
    year: "2019",
  },
  {
    name: "IGNITION",
    img: ignition,
    id: "0012",
    make: "0005",
    model: "24825",
    year: "2019",
  },
  {
    name: "SENSORS",
    img: oxyzensensor,
    id: "0019",
    make: "0005",
    model: "24825",
    year: "2019",
  },
  {
    name: "SENSORS-EXHAUST",
    img: sensorExhaust,
    id: "4502",
    make: "0004",
    model: "24825",
    year: "2019",
  },
];

function FeaturedCategories() {
  const navigate = useNavigate();

  return (
    <div className="bg-[#EFF6FF] py-[50px] lg:py-[50px] md:py-[50px] lg:pr-24 lg:pl-24 md:pr-[65px] md:pl-[65px] pl-2 pr-2">
      <h1 className="container lg:text-5xl font-bold text-blue-900 dark:text-black-700 md:text-5xl text-center pb-3">
        Shop Premium Auto Parts for Your Vehicle
      </h1>
      <hr className="heading-seperator border-4 border-orange-600" />
      <p className="lg:font-normal md:text-base text-gray-700 dark:text-gray-600 text-center lg:text-[1.30rem] lg:pl-11 lg:pr-10 pl-2">
        Find the best auto parts in Canada at our premier auto parts online
        store. Explore a wide selection of original (OEM) and aftermarket auto
        parts designed to keep your vehicle running smoothly. We take pride in
        offering high quality automotive parts at unbeatable prices. Enjoy fast
        order processing, same-day pickup, or delivery within two business
        days. With our extensive catalogue, you’ll find everything you need for
        your car, all in one place. Shop now and experience the perfect blend
        of quality, convenience, and value!
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-2 pb-3">
        {CATEGORIES.map((category, index) => (
          <div
            key={index}
            className="relative overflow-hidden shadow-md rounded-lg border-1 border-gray-300 bg-white cursor-pointer"
            onClick={() =>
              navigate(
                `/shop/vehicles/${category.make}/${category.model}/${category.year}/${category.id}`,
                { state: { skipSearch: true } }
              )
            }
          >
            <img
              src={category.img}
              alt={category.name}
              className="w-full lg:h-[250px] md:h-[200px] h-[250px] object-cover rounded-t"
              loading="lazy"
            />
            <h4 className="text-orange-500 font-bold text-center text-lg py-[10px] mb-0 border-t-2 border-gray-300">
              {category.name}
            </h4>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FeaturedCategories;